import React from "react";
import FlightEngineV2PreviewPage from "../../features/flightEngineV2/preview/FlightEngineV2PreviewPage";

/** Design Preview בלבד — אין integration למנוע הזמנות. */
export default function FlightEngineV2PreviewStandalonePage() {
  return <FlightEngineV2PreviewPage />;
}
